import { Component } from '@angular/core';

@Component({
  selector: 'app-profile-nav',
  templateUrl: './profile-nav.component.html',
  styleUrls: ['./profile-nav.component.css']
})
export class ProfileNavComponent {
  tabs = [
    { label: 'Basic Information', link: '/profile/basic-information',  icon: 'fa-user' },
    { label: 'Work & Social',     link: '/profile/work-and-social',    icon: 'fa-briefcase' },
    { label: 'Referral',          link: '/profile/apply-for-referral', icon: 'fa-handshake' },
    { label: 'Bonus Amount',      link: '/profile/bonus-amount',       icon: 'fa-gift' },
    { label: 'My Contacts',       link: '/profile/my-contacts',        icon: 'fa-address-book' },
    { label: 'Password',          link: '/profile/change-password',    icon: 'fa-lock' }
  ];
}
